import { NavigationItem } from "./types";
import {
  ShoppingBag,
  FolderOpen,
  ClipboardList,
  BarChart3,
  Store,
} from "lucide-react";

const navigation: NavigationItem[] = [
  {
    name: "Product Store",
    href: "#",
    icon: Store,
    current: false,
    internalName: "product-storefront",
    roles: ["ROLE_SUPER_ADMIN"],
    permissions: [],
    isCertainPathOnly: true,
    children: [
      {
        name: "Product Directory",
        href: "/product-storefront/products",
        icon: ShoppingBag,
        current: false,
        internalName: "product-directory",
        roles: ["ROLE_SUPER_ADMIN"],
        permissions: [],
        isCertainPathOnly: true,
      },
    ],
  },
];

const productStorefrontConfig = {
  sectionName: "product-storefront",
  defaultRoute: "/product-storefront/products",
  navigation,
};

export default productStorefrontConfig;
